import ImageGallery, { GalleryImage } from '../../components/carousel/ImageGallery';
import Footer from '../../components/layout/Footer';

const images: GalleryImage[] = [
  { src: '/assets/images/ASD2025/img_7485-800w.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7525.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7486-800w.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7505.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7526.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7488-800w.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7506.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7527.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7490-800w.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7509.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7530.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7493-800w.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7512.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7531.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7496-800w.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7514.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7545.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7518.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7547.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7499-800w.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7519.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7548.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7502-800w.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7523.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7551.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7570.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7590.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7604.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7608.webp', title: 'All Saints Day', alt: 'All Saints Day' },

  { src: '/assets/images/ASD2025/img_7575.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7596.webp', title: 'All Saints Day', alt: 'All Saints Day' },
  { src: '/assets/images/ASD2025/img_7605.webp', title: 'All Saints Day', alt: 'All Saints Day' },
];

const images2: GalleryImage[] = [
  { src: '/assets/images/CMS2025/img_7536.webp', title: 'CML 2025', alt: 'CML 2025' },
  { src: '/assets/images/CMS2025/img_7540.webp', title: 'CML 2025', alt: 'CML 2025' },
  { src: '/assets/images/CMS2025/img_7561.webp', title: 'CML 2025', alt: 'CML 2025' },
  { src: '/assets/images/CMS2025/img_7624.webp', title: 'CML 2025', alt: 'CML 2025' },
  { src: '/assets/images/CMS2025/img_7628.webp', title: 'CML 2025', alt: 'CML 2025' },

  { src: '/assets/images/CMS2025/img_7538.webp', title: 'CML 2025', alt: 'CML 2025' },
  { src: '/assets/images/CMS2025/img_7543.webp', title: 'CML 2025', alt: 'CML 2025' },
  { src: '/assets/images/CMS2025/img_7616.webp', title: 'CML 2025', alt: 'CML 2025' },
  { src: '/assets/images/CMS2025/img_7625.webp', title: 'CML 2025', alt: 'CML 2025' },
  { src: '/assets/images/CMS2025/img_7636.webp', title: 'CML 2025', alt: 'CML 2025' },
];

const feast2025: GalleryImage[] = [
  { src: '/assets/images/ParishFeast2025/IMG_3806.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4189.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4618.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4758.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4778.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },

  { src: '/assets/images/ParishFeast2025/IMG_3870.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4475.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4627.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4764.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4779.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },

  { src: '/assets/images/ParishFeast2025/IMG_4011.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4491.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4741.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4766.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4791.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },

  { src: '/assets/images/ParishFeast2025/IMG_4026.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4584.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4749.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4776.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
  { src: '/assets/images/ParishFeast2025/IMG_4863.webp', title: 'Parish Feast 2025', alt: 'Parish Feast 2025' },
];

const faith2025: GalleryImage[] = [
  { src: '/assets/images/Faith2025/20250530_210816-COLLAGE~2.webp', title: 'Faith Camp 2025', alt: 'Faith Camp 2025' },
  { src: '/assets/images/Faith2025/IMG-20250530-WA0099.webp', title: 'Faith Camp 2025', alt: 'Faith Camp 2025' },
  { src: '/assets/images/Faith2025/20250531_073422-COLLAGE.webp', title: 'Faith Camp 2025', alt: 'Faith Camp 2025' },
  { src: '/assets/images/Faith2025/IMG-20250530-WA0102.webp', title: 'Faith Camp 2025', alt: 'Faith Camp 2025' },
  { src: '/assets/images/Faith2025/20250531_073451-COLLAGE.webp', title: 'Faith Camp 2025', alt: 'Faith Camp 2025' },
  { src: '/assets/images/Faith2025/PXL_20250530_195929398.webp', title: 'Faith Camp 2025', alt: 'Faith Camp 2025' },
  { src: '/assets/images/Faith2025/IMG-20250530-WA0089.webp', title: 'Faith Camp 2025', alt: 'Faith Camp 2025' },
  { src: '/assets/images/Faith2025/PXL_20250530_202621462.webp', title: 'Faith Camp 2025', alt: 'Faith Camp 2025' },
  { src: '/assets/images/Faith2025/IMG-20250530-WA0098.webp', title: 'Faith Camp 2025', alt: 'Faith Camp 2025' },
  { src: '/assets/images/Faith2025/PXL_20250530_204930711.webp', title: 'Faith Camp 2025', alt: 'Faith Camp 2025' },
];

const xmas2025: GalleryImage[] = [
  { src: '/assets/images/xmas2025/xmas1.jpeg', title: 'Christmas 2025', alt: 'Christmas 2025' },
  { src: '/assets/images/xmas2025/xmas2.jpeg', title: 'Christmas 2025', alt: 'Christmas 2025' },
  { src: '/assets/images/xmas2025/xmas3.jpeg', title: 'Christmas 2025', alt: 'Christmas 2025' },
  { src: '/assets/images/xmas2025/xmas4.jpeg', title: 'Christmas 2025', alt: 'Christmas 2025' },
  { src: '/assets/images/xmas2025/xmas5.jpg', title: 'Christmas 2025', alt: 'Christmas 2025' },
  { src: '/assets/images/xmas2025/xmas6.jpeg', title: 'Christmas 2025', alt: 'Christmas 2025' },
  { src: '/assets/images/xmas2025/xmas7.jpeg', title: 'Christmas 2025', alt: 'Christmas 2025' },
  { src: '/assets/images/xmas2025/xmas8.jpeg', title: 'Christmas 2025', alt: 'Christmas 2025' },
  { src: '/assets/images/xmas2025/xmas9.jpeg', title: 'Christmas 2025', alt: 'Christmas 2025' },
  { src: '/assets/images/xmas2025/xmas10.jpg', title: 'Christmas 2025', alt: 'Christmas 2025' },
];

export default function Gallery() {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 text-center my-4">
          <h3>Holy Family Syro-Malabar Catholic Church - Photo Gallery 2025</h3>
        </div>
        <div className="row">
          <div className="col-6 col-md-4">
            <ImageGallery
              images={images}
              thumbnailIndex={0}
              thumbnailAriaLabel="Open gallery"
            />
          </div>
          <div className="col-6 col-md-4">
            <ImageGallery
              images={images2}
              thumbnailIndex={0}
              thumbnailAriaLabel="Open gallery"
            />
          </div>
          <div className="col-6 col-md-4">
            <ImageGallery
              images={feast2025}
              thumbnailIndex={0}
              thumbnailAriaLabel="Open gallery"
            />
          </div>
          <div className="col-6 col-md-4">
            <ImageGallery
              images={faith2025}
              thumbnailIndex={0}
              thumbnailAriaLabel="Open gallery"
            />
          </div>
          <div className="col-6 col-md-4">
            <ImageGallery
              images={xmas2025}
              thumbnailIndex={0}
              thumbnailAriaLabel="Open gallery"
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center my-4">
          <Footer />
        </div>
      </div>
    </div>
  );
}
